import store from '@/store'

export default {

  GetItems: function () {
    let items = [
      {
        name: 'Dashboard',
        url: '/dashboard',
        class: 'dashboard',
        icon: 'icon-speedometer',
        sortOrder: 1,
        roles: ['User', 'Admin']
      },
      {
        name: 'mGauge',
        class: 'mGauge',
        icon: 'fa fa-line-chart',
        sortOrder: 6,
        roles: ['User', 'Admin'],
        children: [
          {
            name: 'Vehicle Sets',
            url: '/mGauge/VehicleSets',
            roles: ['Admin']
          },
          {
            name: 'Default Settings',
            url: '/mGauge/Settings',
            roles: ['Admin']
          },
          {
            name: 'Report Templates',
            url: '/mGauge/RunReport',
            roles: ['Admin']
          },
          {
            name: 'Reports',
            url: '/mGauge/ReportHistory',
            roles: ['User', 'Admin']
          },
          {
            name: 'Vehicle Sampling',
            url: '/mGauge/VehicleSampling',
            roles: ['User', 'Admin']
          },
          {
            name: 'Usage Summary',
            url: '/mGauge/mGaugeUsageSummary',
            roles: ['User', 'Admin']
          }
        ]
      },
      {
        name: 'mScope',
        class: 'mScope',
        icon: 'fa fa-crosshairs',
        sortOrder: 7,
        roles: ['User', 'Admin'],
        children: [
          {
            name: 'Vehicle Sets',
            url: '/mScope/VehicleSets',
            roles: ['Admin']
          },
          {
            name: 'Competitive Mappings',
            url: '/mScope/CompetitiveVehicleMapping',
            roles: ['Admin']
          },
          {
            name: 'Default Settings',
            url: '/mScope/Settings',
            roles: ['Admin']
          },
          {
            name: 'Report Templates',
            url: '/mScope/RunReport',
            roles: ['Admin']
          },
          {
            name: 'Reports',
            url: '/mScope/ReportHistory',
            roles: ['Admin']
          },
          {
            name: 'Vehicle Sampling',
            url: '/mScope/VehicleSampling',
            roles: ['Admin']
          }
          // {
          //  name: 'Usage Summary',
          //  url: '/mScope/mScopeUsageSummary',
          //  roles: ['User', 'Admin']
          // }
        ]
      },
      {
        name: 'PVI',
        class: 'PVI',
        icon: 'fa fa-line-chart',
        sortOrder: 8,
        roles: ['User', 'Admin'],
        subscriptions: ['PVIREPORT'],
        children: [
          {
            name: 'Markets',
            url: '/PVI/Markets',
            roles: ['User', 'Admin']
          },
          {
            name: 'Vehicle Sets',
            url: '/mGauge/VehicleSets',
            roles: ['Admin']
          },
          {
            name: 'Settings',
            url: '/PVI/Settings',
            roles: ['Admin']
          },
          {
            name: 'Reports',
            url: '/PVI/ReportHistory',
            roles: ['User', 'Admin']
          }
        ]
      },
      // {
      //  name: 'mProve Diagnostics',
      //  url: '/mProve',
      //  icon: 'fa fa-line-chart',
      //  sortOrder: 8,
      //  roles: ['User', 'Admin']
      // },
      {
        name: 'mDrive',
        url: '/mDrive',
        class: 'mdrive',
        icon: 'fa fa-power-off',
        sortOrder: 9,
        roles: ['User', 'Admin']
      },
      {
        name: 'mDesking',
        class: 'mDesking',
        url: '/mdesking',
        icon: 'fa fa-pencil-square-o',
        sortOrder: 10,
        roles: ['User', 'Admin']
      },
      {
        name: 'Inventory',
        url: '/Inventory',
        class: 'Inventory',
        icon: 'fa fa-car',
        sortOrder: 11,
        roles: ['Admin']
      },
      {
        name: 'Inventory Quoting Rules',
        url: '/quotepolicies',
        class: 'quotepolicies',
        icon: 'fa fa-file-text',
        sortOrder: 12,
        roles: ['Admin']
      },
      {
        name: 'Dealer Defined Fees',
        url: '/dealerdefinedfees',
        class: 'dealerdefinedfees',
        icon: 'fa fa-usd',
        sortOrder: 13,
        roles: ['Admin']
      },
      {
        name: 'Lenders',
        url: '/lenders',
        class: 'lenders',
        icon: 'fa fa-bank',
        sortOrder: 14,
        roles: ['Admin']
      },
      {
        name: 'Acquisition Fee Markup',
        class: 'bankfeemarkup',
        url: '/bankfeemarkup',
        icon: 'fa fa-level-up',
        sortOrder: 15,
        roles: ['Admin']
      },
      {
        name: 'Rate Markup',
        url: '/ratemarkup',
        class: 'ratemarkup',
        icon: 'fa fa-percent',
        sortOrder: 16,
        roles: ['Admin']
      },
      {
        name: 'Vehicle Equipment',
        url: '/VehicleEquipment',
        class: 'vehicleequipment',
        icon: 'fa fa-plug',
        sortOrder: 17,
        roles: ['Admin']
      },
      {
        name: 'Calculation Settings',
        url: '/calculationsettings',
        class: 'calculationsettings',
        icon: 'fa fa-sliders',
        sortOrder: 18,
        roles: ['Admin']
      },
      {
        name: 'Market Specific Settings',
        url: '/MarketSpecificSettings',
        class: 'marketspecificsettings',
        icon: 'fa fa-sitemap',
        sortOrder: 19,
        roles: ['Admin']
      },
      {
        name: 'Rebate Regions',
        url: '/RebateRegions',
        class: 'rebateregions',
        icon: 'fa fa-money',
        sortOrder: 20,
        roles: ['Admin']
      },
      {
        name: 'Dealer Defaults',
        url: '/DealerSettings',
        class: 'dealersettings',
        icon: 'fa fa-sitemap',
        sortOrder: 22,
        roles: ['Admin']
      },
      {
        name: 'User Management',
        url: '/UserManagement',
        class: 'usermanagement',
        icon: 'fa fa-users',
        sortOrder: 500,
        roles: ['Admin']
      }/*,
      {
        name: 'Settings Differences',
        url: '/SettingsDifferences',
        icon: 'fa fa-money',
        sortOrder: 501,
        roles: ['Admin']
      } */
      // {
      //  name: 'My Profile',
      //  url: '/MyProfile',
      //  icon: 'fa fa-user',
      //  sortOrder: 110,
      //  roles: ['User', 'Admin']
      // },
    ]

    const IsShow = store.getters.GetAcademyShow

    if (IsShow) {
      items.push({
        name: 'Training',
        url: '/academy',
        icon: 'fa fa-graduation-cap',
        sortOrder: 2,
        roles: ['Admin', 'User']
      })
    }

    const forInternalStaff = store.getters.IsInternalStaff

    if (forInternalStaff) {
      var pvi = items.filter(function (e) {
        return e.name === 'PVI'
      })
      if (pvi !== null && pvi !== undefined && pvi.length > 0) {
        pvi[0].children.push({
          name: 'MSIS Email Template',
          url: '/PVI/EmailTemplate',
          icon: 'fa fa-user-secret',
          roles: ['Admin']
        })
      }
    }

    items.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
    items = items.filter(function (item) {
      let result = true

      if (item.roles === undefined) {
        result = true
      } else {
        let currentRole = store.state.currentRole
        result = item.roles.indexOf(currentRole) !== -1
      }

      if (result) {
        if (item.subscriptions !== undefined) {
          let currentSubscription = store.state.subscriptions
          result = currentSubscription.indexOf(item.subscriptions) !== -1
        }
      }

      return result
    })

    return items
  }
}



// WEBPACK FOOTER //
// ./src/_nav.js